import auth from './auth'
import arbitrary from './arbitrary'

export default {
	auth,
	arbitrary,
}
